// The "Rapidsofts" wordmark is baked into the raster as #000082 navy, so it
// cannot be restyled with CSS - which means the logo needs two files, one per
// mode, and both are bundled. rapid.png is the untouched brand original and
// reads on a light ground; rapid-light.png is the same image with the wordmark
// recoloured white for a dark one (the hexagon mark, which also contains navy,
// is byte-for-byte identical between them).
//
// Do not import either directly in a view - components/Logo.js picks between
// them and follows the mode when it changes.
export { default as logo } from "./images/rapid.png";
export { default as logoInverse } from "./images/rapid-light.png";
export { default as upwork } from "./images/upwork.png";
export { default as default_pic } from "./images/default_pic.png";
export { default as default_pic_user } from "./images/default_pic_user.jpg";

